import { useDebounceFn } from "@vueuse/core";
import { computed, defineComponent, ref } from "vue";
import ShortcutHint from "@/components/ui/shortcut-hint/ShortcutHint";
import { useShortcut } from "@/composables/use-shortcut";
import { $t } from "@/services/i18n";
import { p } from "@/utils/props-builder";
import Input from "../input/Input";
import { injectTable } from "./DataTable";

export default defineComponent({
  name: "GlobalFilter",
  props: {
    focusShortcut: p.array<string[]>(["meta", "j"]),
  },
  setup(props) {
    const table = injectTable();
    const inputRef = ref<InstanceType<typeof Input> | null>(null);

    const debouncedSetGlobalFilter = useDebounceFn((value: string) => {
      table.setGlobalFilter(value);
    }, 150);

    const search = computed({
      get() {
        return table.getState().globalFilter;
      },
      set(value) {
        debouncedSetGlobalFilter(value);
      },
    });

    useShortcut(
      () => props.focusShortcut,
      () => inputRef.value?.$el?.querySelector("input")?.focus(),
      { ignoreInputs: false }
    );

    return () => (
      <div class="w-72 flex-none">
        <Input
          ref={inputRef}
          placeholder={$t("search")}
          leftIcon={"lucide:search"}
          v-model={search.value}
        >
          {{
            suffix: () => (
              <span class="text-xs tracking-widest text-muted-foreground opacity-50">
                <ShortcutHint keys={props.focusShortcut} />
              </span>
            ),
          }}
        </Input>
      </div>
    );
  },
});
